import React from "react";
import { getClassName } from "@sscs/utils";
import { InfoIcon } from "../../icons";
import Tooltip from "../Tooltip/Tooltip";
import styles from "./tooltipIcon.module.scss";
const TooltipIcon = ({ title, placement, fitContent, size, className, }) => (React.createElement(Tooltip, { trigger: "graphic", describeChild: true, title: title, placement: placement, fitContent: fitContent },
    React.createElement("span", { className: getClassName(styles["tooltip-icon"], className) },
        React.createElement(InfoIcon, { size: size, color: "disabled" }))));
export default TooltipIcon;
//# sourceMappingURL=TooltipIcon.js.map